export const CONSULTING_PAGES = [
  {
    slug: "visumsberatung-usa",
    badge: "Beratung auf Deutsch",
    title: "Visumsberatung USA: Ihr Weg zum richtigen Visum – auf Deutsch",
    description:
      "Visumsberatung für die USA auf Deutsch: E-2 Visum Beratung, Green Card (EB-2 NIW, EB-1C) und L-1A – wir prüfen Ihre Chancen und koordinieren Ihr Verfahren.",
    keywords:
      "Visumsberatung USA, E-2 Visum Beratung, Auswanderungsberatung USA, Visum Beratung auf Deutsch, US Visum Berater, Auswanderung USA Beratung",
    lead: "E-2, EB-2 NIW, EB-1C oder L-1A? Die US-Visalandschaft ist komplex – und ein falscher Antrag kostet Zeit und Geld. Unsere Visumsberatung auf Deutsch bringt Sie auf den richtigen Weg.",
    faqTitle: "Häufige Fragen zur Visumsberatung",
    blocks: [
      {
        heading: "Unsere Visa-Wege im Überblick",
        paragraphs: [
          "Wir beraten Sie zu allen Wegen, die für Unternehmer, Führungskräfte und Selbstständige aus Deutschland und der Schweiz relevant sind – und sagen Ihnen ehrlich, welcher zu Ihrem Profil passt.",
        ],
        linkList: [
          {
            label: "E-2 Visum – Unternehmervisum",
            href: "/visa/e-2-visum",
            note: "Gründen oder übernehmen Sie ein Unternehmen in den USA – ohne fixen Mindestbetrag.",
          },
          {
            label: "EB-2 NIW – Green Card ohne Arbeitgeber",
            href: "/visa/eb-2-niw-greencard",
            note: "Für Fachkräfte und Unternehmer mit starker Bilanz – direkt zur Green Card.",
          },
          {
            label: "EB-1C – Green Card für Manager",
            href: "/visa/eb-1c-greencard",
            note: "Für Inhaber und Führungskräfte mit Firma im Heimatland.",
          },
          {
            label: "L-1A – Visum für Führungskräfte",
            href: "/visa/l-1a-visum",
            note: "Überstellung in Ihre US-Niederlassung – Sprungbrett zu EB-1C.",
          },
        ],
      },
      {
        heading: "So läuft unsere Visumsberatung ab",
        list: [
          "Kostenloses Erstgespräch: Wir hören zu und prüfen Ihre Ausgangslage",
          "Ehrliche Chancenprüfung: Welcher Weg passt – und welcher nicht",
          "Strategie & Fahrplan: inklusive Businessplan, wenn Ihr Weg einen braucht",
          "Komplette Vorbereitung und Begleitung Ihrer Antragstellung",
          "Vorbereitung auf Interview und Verfahren – bis zur Entscheidung",
        ],
      },
      {
        heading: "Komplettbetreuung von A bis Z",
        paragraphs: [
          "Bei uns bekommen Sie alles aus einer Hand: Wir betreuen Ihr gesamtes Visumsverfahren persönlich und auf Deutsch – von der ersten Strategie über Businessplan und Unterlagen bis zur Antragstellung und der Vorbereitung aufs Konsulat. Sie haben eine Ansprechpartnerin für alles – wir kümmern uns um den Rest.",
        ],
      },
      {
        heading: "Businessplan inklusive",
        paragraphs: [
          "Für E-2, EB-2 NIW und L-1A ist der Businessplan oft das Herzstück des Antrags. Wir erstellen ihn für Sie: visumstauglich, überzeugend für Konsulate und Banken, und abgestimmt auf Ihr Vorhaben in Florida – kein Textbaustein, sondern Ihr echter Plan.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Kein seriöser Berater kann Ihnen ein Visum garantieren – die Entscheidung liegt immer bei den US-Behörden. Vorsicht bei Versprechen wie „100 % Bewilligung“. Was wir Ihnen zusagen: eine ehrliche Chancenprüfung und einen sauber vorbereiteten Fall.",
    },
    faq: [
      {
        q: "Was kostet eine Visumsberatung für die USA?",
        a: "Das Erstgespräch ist kostenlos und unverbindlich. Alles Weitere besprechen wir transparent, bevor etwas entsteht – abgestimmt auf Ihren Weg und Ihr Vorhaben.",
      },
      {
        q: "Können Sie garantieren, dass mein Visum bewilligt wird?",
        a: "Nein – und Sie sollten niemandem trauen, der das verspricht. Wir prüfen Ihre Chancen ehrlich und bereiten Ihren Fall so stark wie möglich vor; die Entscheidung treffen die US-Behörden.",
      },
      {
        q: "Beraten Sie auch bei schwierigen Fällen?",
        a: "Ja. Gerade wenn ein Fall nicht geradlinig ist, lohnt sich die Prüfung: Manchmal ist ein anderer Visumweg die bessere Lösung. Im Erstgespräch sagen wir Ihnen ehrlich, was möglich ist.",
      },
    ],
    closing:
      "Wir prüfen Ihre Chancen, erstellen auf Wunsch Ihren Businessplan und begleiten Ihre Antragstellung komplett – persönlich und auf Deutsch.",
  },
  {
    slug: "einwanderungsanwalt-florida",
    badge: "Komplettservice auf Deutsch",
    title: "Einwanderungsanwalt Florida? So kommen Sie ohne teure Kanzlei zum Visum",
    description:
      "Sie suchen einen deutschsprachigen Einwanderungsanwalt in Florida? Für die meisten Fälle brauchen Sie keine Kanzlei: Wir bereiten Ihren Visumsantrag komplett vor und begleiten Sie durchs ganze Verfahren – auf Deutsch.",
    keywords:
      "Einwanderungsanwalt Florida, Einwanderungsanwalt USA deutschsprachig, Immigration Lawyer Florida deutsch, Visumsantrag USA Hilfe, Visum USA beantragen auf Deutsch",
    lead: "Sie suchen einen Einwanderungsanwalt in Florida, der Deutsch spricht? Die gute Nachricht: Für die meisten Visumsanträge brauchen Sie keine teure Kanzlei. Wir bereiten Ihren Fall vollständig vor, begleiten die Antragstellung und stehen Ihnen durch das gesamte Verfahren zur Seite – persönlich und auf Deutsch.",
    faqTitle: "Häufige Fragen zur Zusammenarbeit",
    blocks: [
      {
        heading: "Komplettservice auf Deutsch – von A bis Z",
        paragraphs: [
          "Sie brauchen sich um nichts selbst zu kümmern: Wir betreuen Ihr gesamtes Einwanderungsvorhaben persönlich und auf Deutsch – von der ersten Chancenprüfung über Businessplan und Unterlagen bis zur fertigen Antragstellung und der Vorbereitung aufs Konsulat.",
          "Für Sie heisst das: Sie sprechen Deutsch, wir kümmern uns um den gesamten Prozess – und Sie wissen bei jedem Schritt genau, wo Ihr Fall steht.",
        ],
      },
      {
        heading: "Was wir für Sie übernehmen",
        list: [
          "Chancenprüfung und Strategie: welcher Visumweg passt zu Ihnen",
          "Vorbereitung Ihrer Unterlagen und Nachweise – auf Deutsch erklärt",
          "Businessplan-Erstellung für E-2, EB-2 NIW oder L-1A",
          "Komplette Antragstellung: Formulare, Nachweise und Begleitschreiben",
          "Vorbereitung auf das Konsulats-Interview",
        ],
      },
      {
        heading: "Warum Sie keine teure Kanzlei brauchen",
        paragraphs: [
          "Direkt zur US-Kanzlei heisst oft: englische Erstberatung, hohe Stundensätze ab dem ersten Gespräch und wenig Verständnis für die Verhältnisse in Deutschland oder der Schweiz. Das meiste an einem Visumsantrag ist keine Juristerei, sondern saubere Vorbereitung: die richtige Strategie, vollständige Unterlagen und ein überzeugender Businessplan.",
          "Genau das ist unsere Arbeit. Bei uns klären Sie zuerst auf Deutsch und kostenlos, ob sich der Weg lohnt – und gehen Ihre Antragstellung erst an, wenn Strategie, Unterlagen und Businessplan stehen.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Kein seriöser Berater kann Ihnen ein Visum garantieren – die Entscheidung liegt immer bei den US-Behörden. Was wir Ihnen zusagen: eine ehrliche Chancenprüfung und einen komplett vorbereiteten Antrag, der dieser Prüfung standhält.",
    },
    faq: [
      {
        q: "Übernehmen Sie mein komplettes Visumsverfahren?",
        a: "Ja – von A bis Z. Wir betreuen Ihren gesamten Fall persönlich und auf Deutsch: Strategie, Businessplan, Unterlagen, Antragstellung und Interview-Vorbereitung. Sie haben dabei immer nur eine Ansprechpartnerin: uns.",
      },
      {
        q: "Wer stellt meinen Visumsantrag?",
        a: "Wir bereiten Ihren Antrag vollständig vor und begleiten Sie durch die Einreichung – Sie müssen sich um nichts kümmern. Vom ersten Formular bis zur Entscheidung bleiben wir an Ihrer Seite.",
      },
      {
        q: "Warum nicht direkt zu einer US-Kanzlei?",
        a: "Weil Sie bei uns zuerst auf Deutsch und kostenlos klären, welcher Weg passt – mit Verständnis für die Verhältnisse in Deutschland und der Schweiz. Sie gehen Ihre Antragstellung vorbereitet an statt bei null zu starten – und sparen sich hohe Stundensätze.",
      },
    ],
    closing:
      "Wir sind Ihre deutschsprachige Anlaufstelle in Florida: Strategie, Businessplan und komplette Antragstellung aus einer Hand – persönlich betreut bis zur Entscheidung.",
  },
  {
    slug: "investorenvisum-usa",
    badge: "Für Unternehmer & Selbstständige",
    title: "Investorenvisum USA: Anforderungen & Wege für Selbstständige",
    description:
      "Investorenvisum USA: E-2 Anforderungen, EB-5 im Überblick und Alternativen für Selbstständige ohne grosse Investition – ehrlich erklärt auf Deutsch.",
    keywords:
      "Investorenvisum USA, Investorenvisum USA Anforderungen, US Visum für Selbstständige, E-2 Visum Anforderungen, EB-5 Visum, Unternehmervisum USA",
    lead: "Sie wollen als Unternehmerin oder Selbstständiger in die USA? Es gibt mehrere Wege – je nachdem, wie viel Sie investieren und ob Sie dauerhaft bleiben wollen. Hier der ehrliche Überblick.",
    faqTitle: "Häufige Fragen zum Investorenvisum",
    blocks: [
      {
        heading: "Welche Wege gibt es für Investoren und Selbstständige?",
        list: [
          "E-2 Visum: der Klassiker – Unternehmen gründen oder kaufen, substanziell investieren, aktiv führen",
          "EB-5: Green Card durch grosse Investition mit Arbeitsplätzen",
          "EB-2 NIW: Green Card ohne Arbeitgeber – für starke Profile und bedeutende Vorhaben",
          "EB-1C / L-1A: für Inhaber bestehender Firmen, die in die USA expandieren",
        ],
      },
      {
        heading: "E-2: das klassische Investorenvisum",
        paragraphs: [
          "Das E-2 Visum ist für die meisten der richtige Einstieg: Sie gründen oder übernehmen ein reales Unternehmen in den USA und führen es aktiv. Entgegen einem hartnäckigen Mythos gibt es keinen gesetzlichen Mindestbetrag – entscheidend ist, dass die Investition im Verhältnis zum Geschäft substanziell ist und wirklich ins Unternehmen fliesst.",
          "Details zu Voraussetzungen, Kosten und Ablauf finden Sie auf unserer E-2-Seite.",
        ],
        linkList: [
          {
            label: "E-2 Visum im Detail",
            href: "/visa/e-2-visum",
            note: "Voraussetzungen, Ablauf, Dauer und der Mythos der 100.000 USD.",
          },
        ],
      },
      {
        heading: "EB-5: Green Card durch grosse Investition",
        paragraphs: [
          "EB-5 ist der direkte Investitionsweg zur Green Card – allerdings mit deutlich höheren Hürden: Derzeit liegt die geforderte Investition bei rund 800.000 USD in geförderten Regionen beziehungsweise etwa 1,05 Millionen USD sonst (Angaben ohne Gewähr, die Schwellen können sich ändern), und es müssen Arbeitsplätze entstehen. Für die meisten unserer Kunden ist E-2 oder EB-2 NIW der pragmatischere Weg.",
        ],
      },
      {
        heading: "US-Visum für Selbstständige – auch ohne grosse Investition",
        paragraphs: [
          "Sie haben kein sechsstelliges Budget? Das schliesst die USA nicht aus: Beim E-2 Visum sind je nach Geschäftsmodell auch deutlich kleinere Summen möglich, wenn der Plan glaubwürdig ist. Und mit einem starken beruflichen Profil kann der EB-2 National Interest Waiver sogar ganz ohne Unternehmensinvestition zur Green Card führen.",
        ],
      },
      {
        heading: "Der Businessplan: Ihr wichtigstes Dokument",
        paragraphs: [
          "Bei jedem Investorenvisum entscheidet der Businessplan mit über die Bewilligung: Er muss zeigen, dass Ihr Geschäft real, tragfähig und mehr als marginal ist. Wir erstellen Businesspläne, die genau das leisten – visumstauglich für Konsulate und überzeugend für Banken.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Bei jedem Investorenvisum gilt: Das Geld muss real und dem Geschäftsrisiko ausgesetzt investiert sein. Ein Betrag auf dem Konto oder ein Scheingeschäft genügt nicht – und führt im Zweifel zur Ablehnung. Wir bauen Ihren Fall so auf, dass er dieser Prüfung standhält.",
    },
    faq: [
      {
        q: "Wie viel muss ich für ein Investorenvisum investieren?",
        a: "Beim E-2 Visum gibt es keinen fixen Mindestbetrag – entscheidend ist die Substanz im Verhältnis zum Geschäft. EB-5 liegt derzeit bei rund 800.000 USD in geförderten Regionen (ohne Gewähr). Was in Ihrem Fall realistisch ist, prüfen wir im Erstgespräch.",
      },
      {
        q: "Gibt es ein US-Visum für Selbstständige ohne grosse Investition?",
        a: "Ja: Beim E-2 Visum sind je nach Geschäftsmodell auch kleinere Investitionen möglich, und mit einem starken beruflichen Profil kann EB-2 NIW ganz ohne Unternehmensinvestition zur Green Card führen.",
      },
      {
        q: "Was ist der Unterschied zwischen E-2 und EB-5?",
        a: "E-2 ist ein befristetes, unbegrenzt verlängerbares Visum mit moderaten Anforderungen an die Investition. EB-5 führt direkt zur Green Card, verlangt aber eine hohe Investition und neue Arbeitsplätze. Wir zeigen Ihnen, welcher Weg zu Ihnen passt.",
      },
    ],
    closing:
      "Wir prüfen Ihre Investitionssituation, empfehlen den passenden Weg und erstellen den Businessplan, der Ihren Antrag trägt – persönlich und auf Deutsch.",
  },
  {
    slug: "unternehmensgruendung-usa",
    badge: "LLC & Corporation",
    title: "Unternehmensgründung in den USA für Deutsche & Schweizer",
    description:
      "Unternehmen in den USA gründen als Deutscher oder Schweizer: LLC oder Corporation, Registered Agent, EIN, Bankkonto und Businessplan – komplett auf Deutsch begleitet.",
    keywords:
      "Unternehmensgründung USA, Unternehmen in den USA gründen, LLC gründen als Deutscher, Firma USA gründen Schweizer, US LLC gründen, Unternehmensgründung Florida",
    lead: "Als Deutscher oder Schweizer können Sie in den USA ein Unternehmen gründen – ohne Staatsbürgerschaft, ohne Green Card, sogar komplett aus dem Ausland. Wir begleiten jeden Schritt auf Deutsch.",
    faqTitle: "Häufige Fragen zur Unternehmensgründung in den USA",
    blocks: [
      {
        heading: "Können Deutsche und Schweizer in den USA gründen?",
        paragraphs: [
          "Ja – uneingeschränkt. Sie brauchen weder die US-Staatsbürgerschaft noch eine Green Card oder ein Visum, um eine LLC oder Corporation zu gründen. Die Gründung ist komplett aus Deutschland oder der Schweiz möglich; erst wenn Sie vor Ort arbeiten wollen, wird das Visum relevant.",
        ],
      },
      {
        heading: "LLC oder Corporation – was passt zu Ihnen?",
        sub: [
          {
            heading: "Die LLC – die erste Wahl der meisten Gründer",
            paragraphs: [
              "Flexibel, unkompliziert und mit Haftungsbegrenzung: Die LLC eignet sich für die meisten kleinen und mittleren Unternehmen und ist steuerlich einfach zu handhaben.",
            ],
          },
          {
            heading: "Die Corporation – für Wachstum mit Investoren",
            paragraphs: [
              "Wenn Sie externes Kapital aufnehmen oder Anteile verkaufen wollen, ist die Corporation (z. B. C-Corp) oft die bessere Struktur. Wir prüfen mit Ihnen, was zu Ihrem Vorhaben passt – auch mit Blick auf Ihre Steuersituation im Heimatland.",
            ],
          },
        ],
      },
      {
        heading: "Die Gründung Schritt für Schritt",
        list: [
          "Firmenname prüfen und Bundesstaat wählen – Florida ist bei Auswanderern beliebt",
          "Registered Agent bestellen (Pflicht – stellt die offizielle US-Adresse)",
          "Gründungsurkunde einreichen (Articles of Organization bzw. Incorporation)",
          "Operating Agreement bzw. Statuten erstellen",
          "EIN (Steuernummer) bei der IRS beantragen",
          "US-Geschäftskonto eröffnen – mit unserer Vorbereitung deutlich einfacher",
          "Website & Homepage: Ihren professionellen Webauftritt für den US-Markt erstellen wir auf Wunsch gleich mit",
        ],
      },
      {
        heading: "Kosten und laufende Pflichten",
        paragraphs: [
          "Die staatlichen Gründungsgebühren liegen in Florida im niedrigen dreistelligen Bereich; dazu kommen je nach Konstellation Kosten für Registered Agent, Businessplan und Bank. Wichtig: der jährliche Annual Report – wird er vergessen, drohen Strafgebühren bis zur Auflösung. Wir behalten das für Sie im Blick.",
        ],
      },
      {
        heading: "Gründung und Visum zusammendenken",
        paragraphs: [
          "Wenn Sie mit der Firma auch auswandern wollen, muss die Unternehmensstruktur zum Visum passen – etwa zum E-2, L-1A oder EB-1C. Genau das ist unsere Stärke: Wir gründen nicht irgendeine Firma, sondern die richtige – inklusive Businessplan, der Visumsantrag und Bank überzeugt.",
        ],
        linkList: [
          {
            label: "Fixfertige Business-Ideen",
            href: "/business-ideen",
            note: "Erprobte Konzepte für Florida – inklusive Businessplan und Gründungsbegleitung.",
          },
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Die Gründung selbst ist schnell erledigt – die Fallstricke liegen danach: Bankkonto, Steuerpflichten in beiden Ländern, jährliche Meldungen. Genau deshalb bleiben wir nach der Gründung an Ihrer Seite statt Sie mit einer Urkunde allein zu lassen.",
    },
    faq: [
      {
        q: "Kann ich ohne Green Card eine US-Firma gründen?",
        a: "Ja. Für die Gründung einer LLC oder Corporation brauchen Sie weder Green Card noch Visum oder Staatsbürgerschaft. Erst wenn Sie in den USA leben und arbeiten wollen, wird das Visum relevant.",
      },
      {
        q: "Kann ich aus Deutschland oder der Schweiz gründen, ohne vor Ort zu sein?",
        a: "Ja, die Gründung ist komplett aus der Ferne möglich. Für das Bankkonto kann je nach Bank eine Reise sinnvoll sein – wir bereiten alles so vor, dass es zügig geht.",
      },
      {
        q: "Brauche ich eine Adresse in den USA?",
        a: "Eine offizielle Adresse im Gründungsstaat brauchen Sie – die stellt der Registered Agent, den wir für Sie organisieren. Eine eigene Büroadresse ist für den Start nicht nötig.",
      },
    ],
    closing:
      "Wir gründen mit Ihnen die richtige Unternehmensform, erstellen Ihren Businessplan und verzahnen alles mit Ihrer Visumsstrategie – persönlich und auf Deutsch.",
  },
  {
    slug: "auswandern-florida",
    badge: "Relocation & Ankommen",
    title: "Auswandern nach Florida: Relocation-Service für Deutsche & Schweizer",
    description:
      "Auswandern nach Florida – mit Begleitung auf Deutsch: Umzug, Wohnungssuche, Versicherungen, Führerschein, Schulen und Alltag. Ihr Relocation-Service für Sarasota und ganz Florida.",
    keywords:
      "Auswandern Florida, Relocation Florida, Umzug nach Florida, Auswandern USA Florida, Relocation Service deutsch, Wohnungssuche Florida, Auswanderung Florida Familie, Ankommen in Florida",
    lead: "Das Visum ist bewilligt, die Firma gegründet – und jetzt? Genau hier fängt die eigentliche Auswanderung an: Umzug, Wohnung, Versicherungen, Führerschein, Schule für die Kinder. Wir organisieren Ihren Neustart in Florida, damit Sie vom ersten Tag an wirklich ankommen.",
    faqTitle: "Häufige Fragen zum Auswandern nach Florida",
    blocks: [
      {
        heading: "Was unser Relocation-Service umfasst",
        list: [
          "Umzugsplanung: Zeitplan, Checklisten und Koordination Ihres internationalen Umzugs",
          "Wohnungssuche: Miete oder Kauf, Ortsteilberatung, Begleitung bei Besichtigungen und Verträgen",
          "Versicherungen: Kranken-, Haftpflicht- und weitere Versicherungen verständlich erklärt",
          "Führerschein & Auto: Umschreibung, Zulassung und was es im Straßenverkehr zu wissen gilt",
          "Schulen & Familie: Schulsystem, Anmeldung und Ankommen für die ganze Familie",
          "Alltag: Bankkonto, Telefon, Internet, Strom – die ersten Schritte im neuen Zuhause",
        ],
      },
      {
        heading: "Wohnen in Florida: Miete oder Kauf?",
        paragraphs: [
          "Die meisten Auswanderer starten zur Miete – das gibt Zeit, Regionen wie Sarasota, Fort Myers, Tampa oder Naples in Ruhe kennenzulernen, bevor eine Kaufentscheidung fällt. Wir beraten Sie zu Ortsteilen, Mietpreisen und den Besonderheiten amerikanischer Mietverträge, die sich deutlich von deutschen und schweizerischen unterscheiden.",
          "Wenn Sie kaufen möchten, begleiten wir den Prozess gemeinsam mit erfahrenen Immobilienmaklern vor Ort – von der Suche über die Prüfung bis zum Abschluss.",
        ],
      },
      {
        heading: "Versicherungen und Gesundheit – der wichtigste Punkt",
        paragraphs: [
          "Das US-Gesundheitssystem funktioniert fundamental anders als in Europa. Eine passende Krankenversicherung ist nicht optional, sondern existenziell – und die Auswahl ist für Neuankömmlinge unübersichtlich. Wir erklären Ihnen die Optionen (Marketplace, private Tarife, Lösungen über die eigene Firma) und begleiten Sie zur passenden Absicherung. Mehr dazu finden Sie in unserem Ratgeber.",
        ],
        linkList: [
          {
            label: "Krankenversicherung in den USA für Einwanderer",
            href: "/ratgeber/krankenversicherung-usa-einwanderer",
            note: "Welche Optionen es gibt und worauf Sie vor der Auswanderung achten müssen.",
          },
          {
            label: "Relocation-Checkliste Florida",
            href: "/ratgeber/relocation-checkliste-florida",
            note: "Schritt für Schritt: alles, was vor und nach dem Umzug zu erledigen ist.",
          },
        ],
      },
      {
        heading: "Mit Familie auswandern",
        paragraphs: [
          "Kinder machen den Umzug nicht einfacher – aber planbarer. Wir beraten Sie zum amerikanischen Schulsystem, zu Schulformen und Anmeldung und dazu, welche Regionen familienfreundlich sind. Auch für Ehepartner ohne eigenes Unternehmen klären wir, welche Möglichkeiten das jeweilige Visum bietet.",
        ],
        linkList: [
          {
            label: "Auswandern nach Florida mit Familie",
            href: "/ratgeber/auswandern-florida-mit-familie",
            note: "Schulen, Visum für Ehepartner und die wichtigsten Familienfragen.",
          },
        ],
      },
      {
        heading: "Warum Florida – und warum mit Begleitung?",
        paragraphs: [
          "Florida ist bei Auswanderern aus Deutschland und der Schweiz beliebt: kein staatlicher Einkommensteuersatz, ein unternehmerfreundliches Klima, ganzjährig Sonne und eine gewachsene deutschsprachige Gemeinschaft. Aber gerade die ersten Monate entscheiden, ob aus dem Plan ein gutes neues Leben wird. Mit uns haben Sie eine Ansprechpartnerin vor Ort, die Deutsch spricht und die Fallstricke kennt – weil sie den Weg selbst gegangen ist.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Die ersten 90 Tage in Florida sind die anstrengendsten: Behörden, Verträge und Absicherung laufen anders als zu Hause, und kleine Fehler werden teuer. Wer diese Phase strukturiert angeht und Unterstützung vor Ort hat, startet entspannter – genau dafür sind wir da.",
    },
    faq: [
      {
        q: "Was kostet ein Relocation-Service für Florida?",
        a: "Das hängt davon ab, was Sie brauchen – von der gezielten Hilfe bei der Wohnungssuche bis zum Rundum-Paket für die ganze Familie. Im kostenlosen Erstgespräch klären wir Ihren Bedarf und machen Ihnen ein transparentes Angebot, bevor etwas entsteht.",
      },
      {
        q: "Helfen Sie auch bei der Wohnungssuche, wenn wir noch in Deutschland oder der Schweiz sind?",
        a: "Ja. Viele Kunden möchten die erste Wohnung vor der Ankunft gesichert haben. Wir recherchieren vor Ort, koordinieren Besichtigungen und bereiten alles so vor, dass Sie bei der Ankunft ein Dach über dem Kopf haben.",
      },
      {
        q: "In welchen Regionen Floridas sind Sie tätig?",
        a: "Unser Schwerpunkt liegt an der Westküste – Sarasota, Bradenton, Fort Myers, Naples – aber wir begleiten Auswanderer in ganz Florida, je nachdem, wohin Ihr Vorhaben Sie führt.",
      },
      {
        q: "Können Sie uns auch beim Visum und der Firmengründung helfen?",
        a: "Ja – genau das ist unsere Stärke: Visumsberatung, Unternehmensgründung und Relocation kommen bei uns aus einer Hand. So ist Ihre Visumsstrategie von Anfang an mit Wohnsitz, Firma und Familie verzahnt.",
      },
    ],
    closing:
      "Von der Umzugsplanung über die Wohnung bis zu Versicherungen und Schulen: Wir organisieren Ihren Neustart in Florida und bleiben auch danach an Ihrer Seite – persönlich und auf Deutsch.",
  },
  {
    slug: "beratung-nach-auswanderung",
    badge: "Auch nach dem Umzug an Ihrer Seite",
    title: "Beratung nach der Auswanderung: Unternehmensberatung in Florida",
    description:
      "Beratung nach der Auswanderung in die USA: laufende Unternehmensberatung, Marketing & Kundengewinnung, lokales Netzwerk und Hilfe im Alltag – deutschsprachig, in Florida.",
    keywords:
      "Unternehmensberatung Florida, Beratung nach Auswanderung, Betreuung nach der Auswanderung USA, deutschsprachige Unternehmensberatung Florida, Business Beratung USA deutsch, Auswanderer Beratung Florida",
    lead: "Die meisten Berater sind weg, sobald das Visum da ist. Wir sind es nicht: Unsere Betreuung endet nicht am Flughafen – sie fängt dort erst richtig an. Wir bleiben Ihre deutschsprachige Ansprechpartnerin in Florida, für Ihr Unternehmen und für alles, was danach kommt.",
    faqTitle: "Häufige Fragen zur Beratung nach der Auswanderung",
    blocks: [
      {
        heading: "Was wir nach Ihrer Ankunft übernehmen",
        list: [
          "Laufende Unternehmensberatung: Strategie, Betrieb und Wachstum Ihres US-Geschäfts",
          "Marketing & Kundengewinnung: Positionierung, Online-Marketing und Neukundengewinnung für den US-Markt",
          "Netzwerk vor Ort: Zugang zu Steuerberatern, Banken und Dienstleistern",
          "Behörden & Pflichten: Annual Reports, Lizenzen und Fristen im Blick behalten",
          "Steuerkoordination: Abstimmung zwischen US-Steuerberater und Ihrer Situation im Heimatland",
          "Alltagsfragen: schnelle Antworten auf Deutsch, wenn etwas unklar ist",
        ],
      },
      {
        heading: "Laufende Unternehmensberatung für Ihr US-Geschäft",
        paragraphs: [
          "Ein Unternehmen in den USA zu führen unterscheidet sich spürbar von Deutschland oder der Schweiz: andere Kundenerwartungen, anderes Marketing, andere Spielregeln. Wir beraten Sie laufend zu Strategie, Betrieb und Wachstum – von der Preisgestaltung über Personal bis zur Frage, ob und wie Sie expandieren.",
          "Und wenn sich Ihre Situation ändert – etwa eine Verlängerung des E-2 Visums oder der Schritt zur Green Card – denken wir Unternehmens- und Visumsstrategie weiterhin zusammen.",
        ],
        linkList: [
          {
            label: "EB-2 NIW – Green Card ohne Arbeitgeber",
            href: "/visa/eb-2-niw-greencard",
            note: "Der nächste Schritt, wenn Ihr Unternehmen in den USA läuft.",
          },
          {
            label: "Steuern bei der Auswanderung in die USA",
            href: "/ratgeber/steuern-auswanderung-usa-dba",
            note: "Doppelbesteuerungsabkommen und was Sie vorab regeln sollten.",
          },
        ],
      },
      {
        heading: "Ein Netzwerk, das trägt",
        paragraphs: [
          "Gute Steuerberater, zuverlässige Handwerker, die richtige Bank – in einem neuen Land braucht es Jahre, sich ein funktionierendes Netzwerk aufzubauen. Unsere Kunden müssen nicht bei null anfangen: Wir vermitteln geprüfte Kontakte aus unserem Netzwerk in Florida und bleiben bei der Zusammenarbeit Ihre Ansprechpartnerin auf Deutsch.",
        ],
      },
      {
        heading: "Warum fortlaufende Begleitung sich lohnt",
        paragraphs: [
          "Die teuersten Fehler von Auswanderern passieren nicht vor, sondern nach dem Umzug: vergessene Meldungen, falsch verstandene Pflichten, verpasste Fristen beim Annual Report oder bei Lizenzen. Mit uns an Ihrer Seite bleibt nichts liegen – und Sie können Ihre Energie in Ihr Unternehmen und Ihr neues Leben stecken statt in Papierkram.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Eine US-Firma muss auch dann laufende Pflichten erfüllen, wenn wenig passiert: jährliche Reports, Steuererklärungen, Lizenzen. Wer das unterschätzt, riskiert Strafgebühren bis zur Zwangsauflösung der Firma. Wir behalten Ihre Fristen im Blick, damit genau das nicht passiert.",
    },
    faq: [
      {
        q: "Betreuen Sie Kunden auch langfristig nach der Auswanderung?",
        a: "Ja, das ist ausdrücklich Teil unseres Modells. Viele unserer Kunden arbeiten seit Jahren mit uns – für laufende Unternehmensberatung, Behördenfragen und alles, was im Leben und Geschäft in Florida anfällt.",
      },
      {
        q: "Was passiert, wenn ich ein akutes Problem habe?",
        a: "Dann melden Sie sich bei uns – per WhatsApp, Telefon oder E-Mail. Wir sind vor Ort in Florida erreichbar und kümmern uns zeitnah, statt Sie an irgendwen weiterzureichen.",
      },
      {
        q: "Koordinieren Sie auch Steuerberater für mich?",
        a: "Ja. Steuerliche Spezialfragen setzen wir mit geprüften Steuerberatern aus unserem Netzwerk um. Wir koordinieren alles, bleiben Ihre deutschsprachige Ansprechpartnerin und sorgen dafür, dass alle Seiten zusammenarbeiten.",
      },
    ],
    closing:
      "Laufende Unternehmensberatung, ein starkes Netzwerk vor Ort und Hilfe bei allem, was nach der Auswanderung kommt: Wir bleiben an Ihrer Seite – persönlich und auf Deutsch.",
  },
  {
    slug: "businessplan-erstellung-usa",
    badge: "Visumstauglich & bankfähig",
    title: "Businessplan erstellen lassen für die USA: überzeugend für Visum & Bank",
    description:
      "Businessplan für die USA erstellen lassen: visumstauglich für E-2, EB-2 NIW und L-1A, überzeugend für Banken und Konsulate. Individuell erstellt – auf Deutsch, für Florida.",
    keywords:
      "Businessplan USA erstellen lassen, Businessplan E-2 Visum, Businessplan für Visumsantrag USA, Businessplan Bank USA, Businessplanerstellung deutsch, Businessplan Florida Unternehmensgründung",
    lead: "Beim E-2 Visum, EB-2 NIW oder L-1A entscheidet der Businessplan oft über Erfolg oder Ablehnung – und auch jede US-Bank will ihn sehen. Wir erstellen Ihren Businessplan individuell: visumstauglich, bankfähig und abgestimmt auf Ihr echtes Vorhaben in Florida.",
    faqTitle: "Häufige Fragen zur Businessplan-Erstellung",
    blocks: [
      {
        heading: "Warum der Businessplan so wichtig ist",
        paragraphs: [
          "Bei unternehmerischen Visumsanträgen ist der Businessplan das Herzstück: Konsulat oder USCIS prüfen daran, ob Ihr Geschäft real ist, tragfähig funktioniert und mehr erwirtschaftet als nur Ihren Lebensunterhalt. Ein schwacher oder generischer Plan ist einer der häufigsten Gründe für Rückfragen und Ablehnungen.",
          "Gleichzeitig brauchen Sie denselben Plan für die Bank: Ohne überzeugende Finanzplanung eröffnet Ihnen kaum eine US-Bank ein Geschäftskonto oder gibt einen Kredit.",
        ],
      },
      {
        heading: "Was in unseren Businessplan gehört",
        list: [
          "Executive Summary und Geschäftsidee – klar und glaubwürdig erzählt",
          "Markt- und Wettbewerbsanalyse für Ihre Zielregion in Florida",
          "Detaillierte Finanzplanung über 5 Jahre: Umsatz, Kosten, Break-even",
          "Personalplanung – bei E-2 besonders wichtig: Arbeitsplätze für US-Arbeitnehmer",
          "Investitionsübersicht: wohin Ihr Kapital konkret fliesst",
          "Umsetzungsfahrplan mit Meilensteinen",
        ],
      },
      {
        heading: "Visumstauglich heisst: auf den Antrag zugeschnitten",
        paragraphs: [
          "Ein Businessplan fürs E-2 Visum liest sich anders als einer für EB-2 NIW oder L-1A – jeder Weg hat eigene Anforderungen, die der Plan adressieren muss. Wir kennen diese Anforderungen und bauen sie gezielt ein, statt eine Vorlage umzufärben. Das Ergebnis besprechen wir mit Ihnen auf Deutsch, bis jede Zahl steht.",
        ],
        linkList: [
          {
            label: "E-2 Visum – Unternehmervisum",
            href: "/visa/e-2-visum",
            note: "Der Klassiker: Unternehmen gründen oder kaufen und aktiv führen.",
          },
          {
            label: "EB-2 NIW – Green Card ohne Arbeitgeber",
            href: "/visa/eb-2-niw-greencard",
            note: "Für starke Profile – hier überzeugt der Plan das USCIS.",
          },
          {
            label: "Fixfertige Business-Ideen",
            href: "/business-ideen",
            note: "Noch ohne eigene Idee? Erprobte Konzepte für Florida inklusive Plan.",
          },
        ],
      },
      {
        heading: "Kein Textbaustein – Ihr echter Plan",
        paragraphs: [
          "Im Netz kursieren Businessplan-Vorlagen für das E-2 Visum – Konsulate kennen sie alle. Wir arbeiten anders: Wir entwickeln den Plan gemeinsam mit Ihnen aus Ihrem echten Vorhaben, mit echten Zahlen aus Ihrer Branche und Region. Das macht den Plan nicht nur überzeugender, sondern auch nützlich: Sie können danach tatsächlich arbeiten.",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Beim E-2 Visum muss das Unternehmen mehr als „marginal“ sein – es darf nicht nur Ihren Lebensunterhalt decken, sondern muss Wachstum und idealerweise Arbeitsplätze zeigen. Genau das muss der Businessplan glaubhaft belegen. Ein generischer Plan scheitert oft genau an dieser Prüfung.",
    },
    faq: [
      {
        q: "Was kostet es, einen Businessplan für die USA erstellen zu lassen?",
        a: "Das hängt von der Komplexität Ihres Vorhabens ab. Im kostenlosen Erstgespräch besprechen wir Ihr Vorhaben und machen Ihnen ein transparentes Festpreis-Angebot – bevor etwas entsteht.",
      },
      {
        q: "Wie lange dauert die Erstellung?",
        a: "In der Regel wenige Wochen – abhängig davon, wie schnell wir Ihre Zahlen und Informationen zusammen haben. Wir halten Sie währenddessen auf Deutsch auf dem Laufenden und stimmen jeden Entwurf mit Ihnen ab.",
      },
      {
        q: "Erstellen Sie auch Pläne, wenn ich noch keine Geschäftsidee habe?",
        a: "Ja. Dann starten wir einen Schritt früher: Mit unseren fixfertigen Business-Ideen für Florida finden wir ein Konzept, das zu Ihnen und Ihrer Visumsstrategie passt – und bauen den Plan darauf auf.",
      },
      {
        q: "Reicht der Businessplan auch für die Bank?",
        a: "Ja. Wir erstellen den Plan so, dass er beide Zwecke erfüllt: visumstauglich für Konsulat oder USCIS und überzeugend für die Eröffnung Ihres US-Geschäftskontos oder eine Finanzierung.",
      },
    ],
    closing:
      "Wir erstellen Ihren Businessplan individuell: visumstauglich für E-2, EB-2 NIW und L-1A, überzeugend für Banken – und so echt, dass Sie danach arbeiten können. Persönlich und auf Deutsch.",
  },
  {
    slug: "auswandern-usa",
    badge: "Der grosse Überblick",
    title: "Auswandern USA: Der komplette Guide für Deutsche & Schweizer",
    description:
      "Auswandern USA: Alle Visa-Wege (E-2, EB-2 NIW, EB-1C, L-1A), Firmengründung, Lebenskosten und Relocation im Überblick – komplette Betreuung auf Deutsch, von A bis Z.",
    keywords:
      "Auswandern USA, Auswandern in die USA, Auswanderung USA, USA Einwanderung, Auswandern USA Unternehmer, Leben in den USA, Auswandern USA als Deutscher, Auswandern USA Schweizer",
    lead: "Sie träumen vom Leben in den USA? Für Unternehmer, Selbstständige und Führungskräfte aus Deutschland und der Schweiz gibt es klare, erreichbare Wege – ohne Lotterie und ohne US-Arbeitgeber. Wir zeigen Ihnen, welcher Weg zu Ihrer Situation passt, und begleiten Sie von der ersten Idee bis zum Ankommen.",
    faqTitle: "Häufige Fragen zum Auswandern in die USA",
    blocks: [
      {
        heading: "Die wichtigsten Visa-Wege im Überblick",
        paragraphs: [
          "Die USA sind ein Einwanderungsland – aber ohne Plan ist der Papierkrieg frustrierend. Für Unternehmer und Führungskräfte gibt es vier bewährte Wege, die wir täglich begleiten:",
        ],
        linkList: [
          {
            label: "E-2 Visum – Unternehmervisum",
            href: "/visa/e-2-visum",
            note: "Der Klassiker: Unternehmen gründen oder kaufen und aktiv führen. Unbegrenzt verlängerbar.",
          },
          {
            label: "EB-2 NIW – Green Card ohne Arbeitgeber",
            href: "/visa/eb-2-niw-greencard",
            note: "Für starke Profile mit aussergewöhnlichen Fähigkeiten – direkter Green-Card-Weg.",
          },
          {
            label: "EB-1C – Green Card für Manager & Unternehmer",
            href: "/visa/eb-1c-greencard",
            note: "Für Inhaber und Führungskräfte mit Firma im Heimatland und US-Engagement.",
          },
          {
            label: "L-1A Visum – Überstellung",
            href: "/visa/l-1a-visum",
            note: "Führungskräfte in die US-Einheit des eigenen Konzerns überstellen.",
          },
        ],
      },
      {
        heading: "Gründen, kaufen oder überstellen?",
        paragraphs: [
          "Es gibt drei realistische Einstiege: Sie gründen ein neues Unternehmen, Sie kaufen ein bestehendes Business – oder Sie haben bereits eine Firma und stellen sich selbst in die USA über. Jeder Weg hat eigene Anforderungen an Investition, Struktur und Nachweise. Genau diese Strategie-Frage klären wir mit Ihnen im Erstgespräch, bevor irgendetwas kostet.",
        ],
        linkList: [
          {
            label: "Firma gründen in Florida",
            href: "/firma-gruenden-florida",
            note: "LLC oder Corporation, EIN, Bankkonto – die Gründung als Fundament.",
          },
          {
            label: "Business kaufen in Florida",
            href: "/business-kaufen-florida",
            note: "Bestehende Firmen mit Kunden und Umsatz – der schnelle E-2 Weg.",
          },
          {
            label: "Fixfertige Business-Ideen",
            href: "/business-ideen",
            note: "Erprobte Konzepte für Florida, abgestimmt auf Ihre Visumsstrategie.",
          },
        ],
      },
      {
        heading: "Leben in den USA: Kosten, Versicherung, Alltag",
        paragraphs: [
          "Ein Visum ist der eine Teil – ein gutes Leben der andere. Lebenskosten, Krankenversicherung, Auto, Schule: Die USA funktionieren anders als Deutschland oder die Schweiz, und wer die Zahlen vorher kennt, startet entspannter. Unsere Ratgeber rechnen ehrlich vor, was das Leben kostet.",
        ],
        linkList: [
          {
            label: "Leben in Florida: Was kostet das wirklich?",
            href: "/ratgeber/lebenskosten-florida",
            note: "Wohnen, Versicherung, Auto, Steuern – realistische Zahlen.",
          },
          {
            label: "Krankenversicherung in den USA",
            href: "/ratgeber/krankenversicherung-usa-einwanderer",
            note: "Der wichtigste Posten – Optionen und Kosten für Einwanderer.",
          },
        ],
      },
      {
        heading: "Warum Florida bei Auswanderern so beliebt ist",
        paragraphs: [
          "Florida ist unter Deutschen und Schweizern der Klassiker: keine staatliche Einkommensteuer, unternehmerfreundlich, ganzjährig Sonne und eine gewachsene deutschsprachige Gemeinschaft. Unsere eigene Auswanderung hat uns genau hierher geführt – heute begleiten wir Sie vor Ort, von Sarasota bis Naples.",
        ],
        linkList: [
          {
            label: "Auswandern nach Florida",
            href: "/auswandern-florida",
            note: "Unser Relocation-Service: Umzug, Wohnung, Versicherungen, Ankommen.",
          },
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Kein seriöser Berater kann Ihnen ein Visum garantieren – die Entscheidung liegt immer bei den US-Behörden. Und: Die Greencard-Lotterie ist für die meisten kein Plan, sondern Glücksspiel. Was wirklich funktioniert, ist eine solide Strategie mit echtem Unternehmen und sauberer Vorbereitung – genau dafür sind wir da.",
    },
    faq: [
      {
        q: "Kann ich ohne eigenes Unternehmen in die USA auswandern?",
        a: "Für unsere Kernzielgruppe – Unternehmer, Selbstständige und Führungskräfte – ist das eigene Unternehmen der stärkste Weg (E-2, EB-1C, L-1A). Falls Sie noch keine Geschäftsidee haben, starten wir mit unseren fixfertigen Business-Ideen. Andere Wege wie Arbeitsvisa über US-Arbeitgeber besprechen wir ehrlich im Erstgespräch.",
      },
      {
        q: "Wie lange dauert die Auswanderung in die USA?",
        a: "Beim E-2 Visum rechnen Sie realistisch mit einigen Monaten von der Strategie bis zum Passstempel – je nach Konsulat und Unterlagenlage. Green-Card-Wege wie EB-2 NIW oder EB-1C laufen länger. Wir geben Ihnen im Erstgespräch einen ehrlichen Zeitrahmen für Ihren Fall.",
      },
      {
        q: "Kann meine Familie mit?",
        a: "Ja. Bei allen vier Wegen können Ehepartner und Kinder mitziehen; Ehepartner dürfen in der Regel auch arbeiten. Schulen, Wohnen und Ankommen als Familie organisieren wir mit unserem Relocation-Service gleich mit.",
      },
      {
        q: "Was kostet die Auswanderung insgesamt?",
        a: "Das hängt vom Weg ab: Investition ins Unternehmen, Gebühren, Umzug und die ersten Monate vor Ort. Im kostenlosen Erstgespräch bekommen Sie eine ehrliche Gesamtrechnung für Ihre Situation – ohne versteckte Kosten.",
      },
    ],
    closing:
      "Von der Weg-Wahl über Gründung und Antragstellung bis zum Ankommen: Wir begleiten Ihre Auswanderung in die USA komplett – persönlich und auf Deutsch.",
  },
  {
    slug: "auswandern-usa-deutscher",
    badge: "Spezial für Deutsche",
    title: "Auswandern USA als Deutscher: Visa, Firma & Neustart in Florida",
    description:
      "Auswandern USA als Deutscher: E-2 Visum, Green Card Wege (EB-2 NIW, EB-1C), Firmengründung, Steuern nach dem DBA und das Leben in Florida – komplette Betreuung auf Deutsch.",
    keywords:
      "Auswandern USA als Deutscher, Auswanderung USA Deutscher, USA Visum für Deutsche, E-2 Visum Deutschland, Deutsche in Florida, DBA Deutschland USA Auswanderung, USA Auswanderung Unternehmer",
    lead: "Als Deutscher haben Sie bei der Auswanderung in die USA ausgezeichnete Karten: Deutschland gehört zu den Vertragsstaaten der wichtigsten Unternehmer-Visa, und das Doppelbesteuerungsabkommen schützt Sie steuerlich. Wir zeigen Ihnen die Wege – und begleiten Sie komplett auf Deutsch.",
    faqTitle: "Fragen von Deutschen zur USA-Auswanderung",
    blocks: [
      {
        heading: "Warum Deutsche gute Karten haben",
        paragraphs: [
          "Deutschland ist Vertragsstaat für das E-2 Unternehmervisum – das heisst: Deutsche Staatsbürger können mit einer eigenen Firma in die USA einwandern, ohne Lotterie und ohne US-Arbeitgeber. Das Visum ist unbegrenzt verlängerbar, solange das Unternehmen läuft. Auch die direkten Green-Card-Wege EB-2 NIW und EB-1C stehen Ihnen offen.",
        ],
        linkList: [
          {
            label: "E-2 Visum – Voraussetzungen & Ablauf",
            href: "/visa/e-2-visum",
            note: "Der beliebteste Weg deutscher Unternehmer in die USA.",
          },
          {
            label: "EB-2 NIW – Green Card ohne Arbeitgeber",
            href: "/visa/eb-2-niw-greencard",
            note: "Der direkte Weg für starke Profile.",
          },
        ],
      },
      {
        heading: "Steuern: Das DBA Deutschland–USA richtig nutzen",
        paragraphs: [
          "Das Doppelbesteuerungsabkommen zwischen Deutschland und den USA sorgt dafür, dass Sie nicht doppelt besteuert werden – aber es regelt nicht alles automatisch. Wegzug, Abmeldung, Wegzugsbesteuerung bei Firmenbeteiligungen und laufende Meldepflichten sollten vor der Auswanderung sauber geplant werden. Wir bereiten alles vor und koordinieren die steuerliche Seite mit geprüften Steuerberatern aus unserem Netzwerk.",
        ],
        linkList: [
          {
            label: "Steuern bei der Auswanderung: Das DBA einfach erklärt",
            href: "/ratgeber/steuern-auswanderung-usa-dba",
            note: "Was Sie vor dem Wegzug regeln sollten.",
          },
        ],
      },
      {
        heading: "Rente, Versicherung & Co.: Was in Deutschland zu regeln ist",
        paragraphs: [
          "Vor dem Wegzug stellen sich klassische Fragen: Was passiert mit meiner gesetzlichen Rente? Freiwillig weiterzahlen oder beitragsfrei stellen? Wie funktioniert die Krankenversicherung in den USA – und was, wenn wir zurückkehren? Diese Themen klären wir strukturiert mit Ihnen, damit in Deutschland nichts liegen bleibt.",
        ],
      },
      {
        heading: "Leben in Florida als Deutscher",
        paragraphs: [
          "Sie sind nicht allein: An Floridas Westküste – Sarasota, Fort Myers, Cape Coral – lebt eine der grössten deutschen Gemeinschaften der USA. Deutsche Bäckereien, Vereine, Stammtische. Dazu kein staatlicher Einkommensteuersatz und ganzjährig Sonne. Unser Relocation-Service bringt Sie und Ihre Familie sicher an – von der Wohnung bis zur Schule.",
        ],
        linkList: [
          {
            label: "Auswandern nach Florida – Relocation-Service",
            href: "/auswandern-florida",
            note: "Umzug, Wohnung, Versicherungen, Ankommen.",
          },
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Die deutsche Staatsbürgerschaft müssen Sie für ein US-Visum nicht aufgeben – und auch eine Green Card ändert daran nichts. Erst eine spätere US-Einbürgerung wäre ein separates Thema. Die meisten unserer Kunden leben dauerhaft in den USA und bleiben ganz entspannt deutsche Staatsbürger.",
    },
    faq: [
      {
        q: "Brauche ich als Deutscher überhaupt ein Visum?",
        a: "Für Urlaub reicht ESTA – zum Leben und Arbeiten brauchen Sie ein Visum oder eine Green Card. Für Unternehmer ist das E-2 Visum der bewährteste Weg: Deutschland ist Vertragsstaat, das Visum ist unbegrenzt verlängerbar und die Familie zieht mit.",
      },
      {
        q: "Was passiert mit meiner deutschen Rente?",
        a: "Ihre erworbenen Ansprüche bleiben grundsätzlich erhalten und werden auch in die USA gezahlt. Ob freiwillige Weiterzahlungen sinnvoll sind, hängt von Ihrer Situation ab – wir besprechen das strukturiert und ziehen bei Bedarf Spezialisten aus unserem Netzwerk hinzu.",
      },
      {
        q: "Muss ich mich in Deutschland abmelden?",
        a: "Ja, bei einem dauerhaften Wegzug ist die Abmeldung Pflicht – und sie hat steuerliche Konsequenzen, die man vorher kennen sollte, besonders bei Firmenbeteiligungen (Stichwort Wegzugsbesteuerung). Wir planen den Wegzug mit Ihnen sauber, statt Sie überraschen zu lassen.",
      },
    ],
    closing:
      "Von der Visumsstrategie über die Gründung bis zum Wegzug aus Deutschland: Wir begleiten Ihre Auswanderung in die USA komplett – aus eigener Erfahrung, auf Deutsch.",
  },
  {
    slug: "auswandern-florida-schweizer",
    badge: "Spezial für Schweizer",
    title: "Auswandern Florida als Schweizer: Visum, Gründung & Ankommen",
    description:
      "Als Schweizer nach Florida auswandern: E-2 Visum und Green Card Wege, Firmengründung, Steuern nach dem DBA Schweiz–USA und Relocation – komplette Betreuung auf Deutsch.",
    keywords:
      "Auswandern Florida als Schweizer, Auswandern USA Schweizer, Schweizer in Florida, E-2 Visum Schweiz, Auswanderung Schweiz USA, DBA Schweiz USA, Florida auswandern",
    lead: "Als Schweizerin oder Schweizer stehen Ihnen in den USA dieselben starken Unternehmer-Visa offen wie Deutschen – inklusive E-2. Dazu kommen Schweizer Besonderheiten bei AHV, Pensionskasse und DBA, die man vor dem Wegzug sauber klären sollte. Wir begleiten Sie komplett – in Ihrer Sprache, aus eigener Erfahrung.",
    faqTitle: "Fragen von Schweizern zur Florida-Auswanderung",
    blocks: [
      {
        heading: "Warum Schweizer gute Karten haben",
        paragraphs: [
          "Die Schweiz ist Vertragsstaat des E-2 Unternehmervisums: Mit einer eigenen Firma in den USA erhalten Sie ein unbegrenzt verlängerbares Visum – ohne Lotterie, ohne US-Arbeitgeber. Auch die Green-Card-Wege EB-2 NIW und EB-1C stehen Schweizer Staatsbürgern offen. Und das Doppelbesteuerungsabkommen Schweiz–USA schützt Sie vor doppelter Besteuerung.",
        ],
        linkList: [
          {
            label: "E-2 Visum – Voraussetzungen & Ablauf",
            href: "/visa/e-2-visum",
            note: "Der beliebteste Weg von Unternehmern aus der Schweiz.",
          },
          {
            label: "Unternehmensgründung in den USA",
            href: "/unternehmensgruendung-usa",
            note: "LLC oder Corporation – das Fundament Ihres Visums.",
          },
        ],
      },
      {
        heading: "AHV, Pensionskasse & 3. Säule: Vorsorge beim Wegzug",
        paragraphs: [
          "Beim Wegzug in die USA stellen sich typische Schweizer Fragen: Bleibe ich AHV-versichert oder melde ich mich ab? Was passiert mit meinem Pensionskassenguthaben – Auszahlung oder Freizügigkeitskonto? Lohnt sich die 3. Säule weiter? Diese Entscheide haben Steuerfolgen in beiden Ländern. Wir klären sie strukturiert mit Ihnen und koordinieren bei Bedarf geprüfte Spezialisten aus unserem Netzwerk.",
        ],
        linkList: [
          {
            label: "Steuern bei der Auswanderung: Das DBA einfach erklärt",
            href: "/ratgeber/steuern-auswanderung-usa-dba",
            note: "Doppelbesteuerung vermeiden – was Sie vorab regeln sollten.",
          },
        ],
      },
      {
        heading: "Krankenversicherung: Der grösste Unterschied zur Schweiz",
        paragraphs: [
          "Aus dem Schweizer KVG-System kommt das US-System zunächst fremd vor – und die Krankenversicherung wird zum wichtigsten Posten im Budget. Wir erklären Ihnen die Optionen (Marketplace, private Tarife, Absicherung über die eigene Firma) und sorgen dafür, dass Sie vom ersten Tag an richtig versichert sind.",
        ],
        linkList: [
          {
            label: "Krankenversicherung in den USA für Einwanderer",
            href: "/ratgeber/krankenversicherung-usa-einwanderer",
            note: "Optionen und Kosten im Überblick.",
          },
        ],
      },
      {
        heading: "Leben in Florida als Schweizer",
        paragraphs: [
          "Viele Schweizer schätzen an Florida, was sie von zu Hause kennen – Ordnung und Qualität – kombiniert mit dem, was zu Hause fehlt: ganzjährig Sonne, kein Staats-Einkommensteuersatz und Meer vor der Tür. An der Westküste um Sarasota und Fort Myers gibt es eine gewachsene Schweizer Gemeinschaft. Unser Relocation-Service bringt Sie sicher an – von der Wohnung bis zum Führerschein.",
        ],
        linkList: [
          {
            label: "Auswandern nach Florida – Relocation-Service",
            href: "/auswandern-florida",
            note: "Umzug, Wohnung, Versicherungen, Ankommen.",
          },
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Die Schweizer Staatsbürgerschaft behalten Sie mit US-Visum oder Green Card problemlos – die Schweiz kennt die doppelte Staatsbürgerschaft, und eine Green Card ist noch keine Einbürgerung. Sie können also ganz entspannt in Florida leben und bleiben Schweizerin oder Schweizer.",
    },
    faq: [
      {
        q: "Können Schweizer das E-2 Visum bekommen?",
        a: "Ja. Die Schweiz ist E-2-Vertragsstaat der USA: Mit einer eigenen, aktiv geführten Firma in den USA erhalten Schweizer Staatsbürger das E-2 Visum – unbegrenzt verlängerbar, Familie inklusive. Wir prüfen im kostenlosen Erstgespräch, ob es zu Ihrem Vorhaben passt.",
      },
      {
        q: "Was passiert mit meiner Pensionskasse beim Wegzug in die USA?",
        a: "Beim definitiven Wegzug in einen Nicht-EU/EFTA-Staat wie die USA ist eine Auszahlung des obligatorischen Pensionskassenguthabens grundsätzlich möglich – alternativ parkieren Sie es auf einem Freizügigkeitskonto. Beides hat Steuerfolgen in beiden Ländern; wir planen das mit Ihnen vor der Auswanderung.",
      },
      {
        q: "Muss ich in der Schweiz weiter Steuern zahlen?",
        a: "Nach einem sauberen Wegzug mit Aufgabe des Wohnsitzes besteuert die Schweiz grundsätzlich nur noch bestimmte Schweizer Einkünfte (z. B. aus Liegenschaften). Das DBA Schweiz–USA regelt die Details. Wichtig ist ein sauberer, dokumentierter Wegzug – genau dabei helfen wir.",
      },
    ],
    closing:
      "Von der Visumsstrategie über Vorsorge und Gründung bis zum Ankommen in Florida: Wir begleiten Schweizer komplett – persönlich und in Ihrer Sprache.",
  },
  {
    slug: "firma-gruenden-florida",
    badge: "Gründung in Florida",
    title: "Firma gründen in Florida: LLC & Corporation für Deutsche & Schweizer",
    description:
      "Firma in Florida gründen: LLC oder Corporation, Registered Agent, EIN, Geschäftskonto und Lizenzen – komplette Gründungsbegleitung auf Deutsch. Auch das perfekte Fundament fürs E-2 Visum.",
    keywords:
      "Firma gründen Florida, LLC gründen Florida, Unternehmen gründen USA, Firma in Florida gründen, US Firma gründen Deutscher, LLC USA Schweizer, Geschäftskonto USA eröffnen, Unternehmensgründung Florida",
    lead: "Eine Firma in Florida zu gründen ist erstaunlich unkompliziert – wenn man weiss, wie: keine Staats-Einkommensteuer, schlanke Bürokratie, komplett aus dem Ausland möglich. Wir gründen mit Ihnen die richtige Unternehmensform und verzahnen sie von Anfang an mit Ihrer Visumsstrategie.",
    faqTitle: "Häufige Fragen zur Firmengründung in Florida",
    blocks: [
      {
        heading: "LLC oder Corporation – was passt zu Ihnen?",
        paragraphs: [
          "Für die meisten Auswanderer ist die LLC die richtige Wahl: Sie trennt Privat- und Firmenvermögen, ist flexibel in der Führung und steuerlich unkompliziert. Eine Corporation lohnt sich bei Investoren oder geplantem starkem Wachstum. Die Entscheidung hat Folgen für Steuern und Visum – wir treffen sie gemeinsam mit Ihnen, mit Blick auf beide Seiten des Atlantiks.",
        ],
      },
      {
        heading: "Die Gründung Schritt für Schritt",
        list: [
          "Firmennamen prüfen und festlegen",
          "Registered Agent bestellen (in Florida Pflicht)",
          "Gründungsurkunde beim Staat Florida einreichen (Sunbiz)",
          "Operating Agreement erstellen – die internen Spielregeln",
          "EIN (US-Steuernummer) bei der IRS beantragen",
          "US-Geschäftskonto eröffnen",
          "Lizenzen und lokale Anmeldungen – je nach Branche",
          "Website & Homepage: Ihren professionellen Webauftritt für den US-Markt erstellen wir auf Wunsch direkt mit",
        ],
      },
      {
        heading: "Kosten und laufende Pflichten",
        paragraphs: [
          "Die staatlichen Gebühren in Florida liegen im niedrigen dreistelligen Bereich – dazu kommen je nach Setup Registered Agent, Bank und Beratung. Wichtig zu wissen: Jede Florida-Firma muss jährlich einen Annual Report einreichen und ihre Steuererklärung machen – auch wenn wenig passiert. Vergisst man das, drohen Strafgebühren bis zur Zwangsauflösung. Unsere Betreuung nach der Gründung behält diese Fristen für Sie im Blick.",
        ],
        linkList: [
          {
            label: "Beratung nach der Auswanderung",
            href: "/beratung-nach-auswanderung",
            note: "Laufende Betreuung: Fristen, Steuern, Wachstum.",
          },
          {
            label: "LLC in Florida gründen – der Ratgeber",
            href: "/ratgeber/llc-in-florida-gruenden",
            note: "Der ausführliche Leitfaden mit allen Details.",
          },
        ],
      },
      {
        heading: "Die Gründung als Fundament Ihres Visums",
        paragraphs: [
          "Für das E-2 Visum ist Ihre US-Firma das Fundament: Die Investition muss in ein echtes, aktives Unternehmen fliessen, und der Businessplan muss zeigen, dass daraus ein tragfähiges Geschäft wird. Deshalb gründen wir bei uns nie isoliert – Firmenform, Kapitalstruktur und Businessplan entstehen bei uns abgestimmt auf Ihren Visumsweg.",
          "Und damit Ihr neues Unternehmen von Tag eins an professionell auftritt: Auf Wunsch erstellen wir auch Ihre Homepage für den US-Markt – mit Texten und Auftritt, die amerikanische Kunden überzeugen.",
        ],
        linkList: [
          {
            label: "E-2 Visum – Voraussetzungen & Ablauf",
            href: "/visa/e-2-visum",
            note: "Das Unternehmervisum, für das Ihre Firma gebaut wird.",
          },
          {
            label: "Businessplan erstellen lassen",
            href: "/businessplan-erstellung-usa",
            note: "Visumstauglich und bankfähig – individuell erstellt.",
          },
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "Eine US-Firma zu gründen ist der einfache Teil – die Fallstricke kommen danach: jährliche Reports, Steuererklärungen in zwei Ländern, Banken, die Ausländern skeptisch begegnen. Wer von Anfang an mit sauberer Struktur und Businessplan gründet, spart sich später teure Korrekturen.",
    },
    faq: [
      {
        q: "Kann ich die Firma aus Deutschland oder der Schweiz gründen?",
        a: "Ja. Die Gründung in Florida ist komplett aus dem Ausland möglich – Sie müssen dafür nicht einreisen. Wir erledigen Namensprüfung, Einreichung und EIN für Sie; nur für bestimmte Bankkonten kann je nach Bank eine persönliche Reise sinnvoll sein.",
      },
      {
        q: "Wie lange dauert die Gründung?",
        a: "Die staatliche Registrierung geht in Florida schnell – wenige Tage. Die EIN-Steuernummer für Ausländer ohne US-Sozialversicherungsnummer dauert bei der IRS typischerweise einige Wochen. Wir planen das in Ihren Gesamtfahrplan ein, damit nichts auf dem Weg zum Visum wartet.",
      },
      {
        q: "Was kostet eine Firmengründung in Florida?",
        a: "Die staatlichen Gebühren liegen im niedrigen dreistelligen Bereich. Das Gesamtpaket hängt davon ab, was Sie brauchen – von der reinen Gründung bis zum Komplett-Setup mit EIN, Bankkonto, Businessplan und Visumsverzahnung. Im kostenlosen Erstgespräch bekommen Sie ein transparentes Angebot.",
      },
      {
        q: "Brauche ich eine US-Adresse für die Firma?",
        a: "Ihre Firma braucht einen Registered Agent mit Adresse in Florida – das übernehmen wir bzw. organisieren wir für Sie. Eine eigene Büroadresse ist für viele Geschäftsmodelle zunächst nicht nötig; fürs Visum kann sie aber sinnvoll sein – das stimmen wir auf Ihre Strategie ab.",
      },
    ],
    closing:
      "Wir gründen Ihre Firma in Florida komplett: richtige Form, EIN, Bankkonto und Businessplan – verzahnt mit Ihrer Visumsstrategie, persönlich und auf Deutsch.",
  },
  {
    slug: "business-kaufen-florida",
    badge: "Für Käufer mit Kapital",
    title: "Business kaufen in Florida: Der schnelle Weg zum E-2 Visum",
    description:
      "Business kaufen in Florida: Bestehende Unternehmen mit Kunden und Umsatz als direkter Weg zum E-2 Visum – Auswahl, Bewertung, Due Diligence und Übernahme, komplett begleitet auf Deutsch.",
    keywords:
      "Business kaufen Florida, Unternehmen kaufen USA, Firma kaufen Florida, E-2 Visum Unternehmen kaufen, Geschäft kaufen Florida, Business Broker Florida deutsch, Unternehmenskauf USA, Franchise Florida",
    lead: "Statt bei null zu starten, kaufen Sie ein bestehendes Business: mit Kunden, Umsatz und Mitarbeitenden ab dem ersten Tag. Für das E-2 Visum ist das oft der schnellste und überzeugendste Weg – wenn das Geschäft stimmt. Wir begleiten Sie von der Suche über die Prüfung bis zur Übernahme.",
    faqTitle: "Häufige Fragen zum Unternehmenskauf in Florida",
    blocks: [
      {
        heading: "Warum kaufen statt gründen?",
        paragraphs: [
          "Ein bestehendes Business bringt mit, was eine Neugründung erst aufbauen muss: laufende Umsätze, einen Kundenstamm, eingespielte Abläufe und oft Mitarbeitende. Fürs E-2 Visum ist das ein starkes Argument – die Wirtschaftlichkeit ist nicht Prognose, sondern nachweisbare Realität. Gleichzeitig ist ein Kauf komplexer: Was genau kaufen Sie, und zu welchem Preis?",
        ],
      },
      {
        heading: "Worauf es beim Unternehmenskauf ankommt",
        list: [
          "Echte Zahlen: Steuererklärungen und Bücher des Verkäufers prüfen, nicht nur Hochglanz-Unterlagen",
          "Kundenbindung: Bleiben die Kunden nach dem Inhaberwechsel?",
          "Mitarbeitende: Gibt es Schlüsselpersonen, und bleiben sie?",
          "Kaufpreis & Verhandlung: realistische Bewertung statt Bauchgefühl",
          "Asset Deal vs. Firmenkauf: Was genau übernehmen Sie – inklusive Altlasten?",
          "Übergabe: Wie lange führt der Verkäufer Sie ein?",
        ],
      },
      {
        heading: "Der Kauf als Fundament fürs E-2 Visum",
        paragraphs: [
          "Beim E-2 Visum muss Ihre Investition „at risk“ in ein echtes, aktives Unternehmen fliessen – ein gekauftes Business mit nachweisbaren Umsätzen erfüllt das ideal. Wichtig: Kaufvertrag und Zahlungsfluss müssen sauber dokumentiert sein, denn genau das prüft das Konsulat. Wir stimmen Kaufstruktur, Businessplan und Visumsantrag von Anfang an aufeinander ab.",
        ],
        linkList: [
          {
            label: "E-2 Visum – Voraussetzungen & Ablauf",
            href: "/visa/e-2-visum",
            note: "Warum ein gekauftes Business beim Konsulat überzeugt.",
          },
          {
            label: "Businessplan erstellen lassen",
            href: "/businessplan-erstellung-usa",
            note: "Auch beim Kauf entscheidend: Ihr Plan für die nächsten 5 Jahre.",
          },
        ],
      },
      {
        heading: "So läuft der Kauf mit uns ab",
        list: [
          "Profil & Budget: Welche Branche, Region und Grösse passt zu Ihnen",
          "Suche & Vorauswahl: passende Angebote prüfen, bevor Sie reisen",
          "Bewertung & Verhandlung: realistischer Preis, saubere Bedingungen",
          "Due Diligence: Bücher, Verträge und Risiken systematisch prüfen",
          "Kaufvertrag & Übergabe: koordiniert und auf Deutsch erklärt",
          "Verzahnung mit Visum, Businessplan und Relocation",
        ],
      },
    ],
    myth: {
      title: "Gut zu wissen",
      text: "In den USA werden viele kleine Firmen über Business Broker verkauft – und deren erste Unterlagen zeigen fast immer die Sonnenseite. Entscheidend sind die Steuererklärungen der letzten Jahre und die Frage, warum wirklich verkauft wird. Wer das systematisch prüft, kauft ein Geschäft – nicht dessen Probleme.",
    },
    faq: [
      {
        q: "Welches Budget brauche ich für einen Unternehmenskauf in Florida?",
        a: "Solide kleine Betriebe – etwa im Service-, Reinigungs- oder Pflegebereich – gibt es ab dem mittleren fünfstelligen Bereich; etablierte Firmen mit starken Zahlen liegen deutlich höher. Fürs E-2 Visum zählt neben dem Preis vor allem, dass Investition und Betrieb glaubhaft zusammenpassen. Im Erstgespräch klären wir, welches Budget zu Ihrem Weg passt.",
      },
      {
        q: "Wie lange dauert ein Unternehmenskauf?",
        a: "Von der ernsthaften Suche bis zur Übergabe sollten Sie einige Monate einplanen: Suche und Vorauswahl, Prüfung, Verhandlung und Vertrag. Wir strukturieren den Prozess so, dass er sich sauber in Ihren Visumsfahrplan fügt.",
      },
      {
        q: "Kann ich den Kauf finanzieren?",
        a: "Teilfinanzierungen sind möglich – etwa über den Verkäufer (Seller Financing), der in den USA üblich ist. Fürs E-2 Visum muss der eigenfinanzierte Teil glaubhaft und aus nachvollziehbaren Mitteln stammen. Wir besprechen ehrlich, welche Struktur für Ihren Antrag funktioniert.",
      },
      {
        q: "Was ist besser fürs Visum: kaufen oder gründen?",
        a: "Beides funktioniert – es hängt von Ihnen ab: Ein gekauftes Business bringt nachweisbare Umsätze mit, eine Gründung gibt Ihnen maximale Freiheit und oft tieferen Kapitaleinsatz. Genau diese Abwägung machen wir im Erstgespräch gemeinsam – ehrlich und ohne Verkaufsdruck.",
      },
    ],
    closing:
      "Wir begleiten Ihren Unternehmenskauf in Florida komplett: von der Suche über die Prüfung bis zur Übernahme – verzahnt mit Visum und Businessplan, persönlich und auf Deutsch.",
  },
];

export function getConsultingPage(slug) {
  return CONSULTING_PAGES.find((p) => p.slug === slug);
}
